var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_91_86)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0005 14.2681C15.3161 14.2682 17.4329 14.9288 18.729 15.9908C20.0563 17.0784 20.4038 18.4859 20.4038 19.6705V20.4039H3.59619V19.6705C3.5962 18.5429 3.94831 17.1427 5.26611 16.0435C6.55973 14.9646 8.6763 14.2681 12.0005 14.2681Z",
    stroke: "#F4F4F9",
    strokeWidth: 1.4674
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.9333,
    cy: 7.93132,
    r: 3.6685,
    stroke: "#F4F4F9",
    strokeWidth: 1.4674
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_91_86"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.009,
    height: 18.009,
    fill: "white",
    transform: "translate(2.99561 2.99551)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyProfile);
export default __webpack_public_path__ + "static/media/MyProfile.95e21a0f19ee64cff30fa74c9aaeaa0b.svg";
export { ForwardRef as ReactComponent };